// extracted by mini-css-extract-plugin
export default {"primaryButton":"styles_primaryButton__FYDHd","primaryButtonText":"styles_primaryButtonText__9AuUG"};